import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { ProductDetailPageComponent } from './pages/product-detail-page.component';
import { ProductListPageComponent } from './pages/product-list-page.component';
import { SearchProductsPageComponent } from './pages/search-products-page.component';

const routes: Routes = [
    {
        path: '',
        component: ProductListPageComponent,
        canActivate: []
    },
    {
        path: ':productCode',
        component: ProductDetailPageComponent,
        // canActivate: [AuthGuard],
        // data: {
        //     roles: ['UserManagement', 'Administrator']
        // }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProductsRoutingModule { }
